import { ITableChapter } from "../models/chapter";
import { getAuthorizationProperties } from "./authorizationHelper";

export async function getTablesForChapters(guid: string): Promise<ITableChapter[]> {
    let res = await fetch(`/api/tableChapters/${guid}`, {
        method: "GET",
        ...getAuthorizationProperties({ "Content-Type": "application/json" }),
    });
    return res.json();
}

export async function addTableToChapter(
    tableChapter: Partial<ITableChapter>
): Promise<ITableChapter> {
    let res = await fetch(`/api/tableChapters`, {
        method: "POST",
        ...getAuthorizationProperties({ "Content-Type": "application/json" }),
        body: JSON.stringify(tableChapter),
    });
    return res.json();
}

export async function removeTableFromChapter(guid: string) {
    return await fetch(`/api/tableChapters/${guid}`, {
        method: "DELETE",
        ...getAuthorizationProperties({ "Content-Type": "application/json" }),
    });
}

export async function updateTableChapter(tableChapter: ITableChapter) {
    return await fetch(`/api/tableChapters/${tableChapter.id}`, {
        method: "PUT",
        ...getAuthorizationProperties({ "Content-Type": "application/json" }),
        body: JSON.stringify(tableChapter),
    });
}
